import React, { createContext, useContext, useState } from 'react';
import AlertModal from '../components/AlertModal';

const AlertContext = createContext();

export const useAlert = () => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error('useAlert must be used within an AlertProvider');
  }
  return context;
};

export const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState({
    isOpen: false,
    message: '',
    type: 'error'
  });

  const showAlert = (message, type = 'error') => {
    setAlert({
      isOpen: true,
      message,
      type
    });
  };

  const hideAlert = () => {
    setAlert({
      isOpen: false,
      message: '',
      type: 'error'
    });
  };

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      <AlertModal
        isOpen={alert.isOpen}
        message={alert.message}
        type={alert.type}
        onClose={hideAlert}
      />
    </AlertContext.Provider>
  );
};
